<template>
  <svg
    :width="width ? width : height ? height * (12 / 17) : 12"
    :height="height ? height : width ? width * (17 / 12) : 17"
    viewBox="0 0 12 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M6.543.831l4.9922 5.5238c.3038.3358.0707.881-.3776.881H7.7068v8.7865a.64.64 0 0 1-.64.64H5.264a.64.64 0 0 1-.64-.64V7.2357H1.1732c-.4477 0-.6815-.5444-.3777-.881L5.7877.831a.507.507 0 0 1 .7553 0z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'continue',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
